import React from 'react';
import { t } from 'i18next';
export const NoDataToDisplay = () => {
  return (
    <div className="rendered no-data w-full text-center">
      <div className="flex h-full flex-col justify-center"> {String(t('noData'))}</div>
    </div>
  );
};
